export const getSumByArgs = (...sizes: number[]) => {
	let h = 0

	for (let i = 0, { length } = sizes; i < length; i++) {
		h += sizes[i]
	}

	return h
}
